export default "__VITE_ASSET__BSc4ECJc__"